module.exports = __webpack_public_path__ + "img/aura.ba516133.svg";